import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "templates-footer",
  class: "default-footer uk-flex"
}
const _hoisted_2 = { class: "inner-wrapper uk-flex uk-flex-between" }
const _hoisted_3 = { class: "app-copyright" }
const _hoisted_4 = { class: "app-version" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, " Copyright © 2015 - " + _toDisplayString(_ctx.currentYear) + ". Pair Finance GmbH ", 1),
      _createElementVNode("span", _hoisted_4, "Version: " + _toDisplayString(_ctx.appVersion ?? '—'), 1)
    ])
  ]))
}